// extracted by mini-css-extract-plugin
export default {"aboutUs":"index_aboutUs_r0nDR"};